import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from '@edx/frontend-platform/i18n';
import { IS_STARTED_STATUS } from '../constants';
import TimerProvider from './TimerProvider';
import { Emitter } from '../data';
import {
  TIMER_5_MIN_LEFT,
} from './events';
import FiveMinuteCountDownTimer from './FiveMinuteCountDownTimer';

/**
 * Exam timer block component.
 */
const FiveMinuteWarning = injectIntl(({
  attempt, stopExamAttempt, expireExamAttempt, pollExamAttempt,
  intl, pingAttempt, submitExam,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  if (!attempt || !IS_STARTED_STATUS(attempt.attempt_status)) {
    return null;
  }

  const onFiveMinutesLeft = () => setIsVisible(true);

  useEffect(() => {
    Emitter.once(TIMER_5_MIN_LEFT, onFiveMinutesLeft);
    // Emitter.once(TIMER_LIMIT_REACHED, expireExamAttempt);

    return () => {
      Emitter.off(TIMER_5_MIN_LEFT, onFiveMinutesLeft);
      // Emitter.off(TIMER_LIMIT_REACHED, expireExamAttempt);
    };
  }, []);

  const className = `five-minute-warning${isVisible ? ' five-minute-warning--visible' : ''}`;

  return (
    <TimerProvider attempt={attempt} pollHandler={pollExamAttempt} pingHandler={pingAttempt}>
      <div className={className}>
        Уважаемый слушатель, ваш экзамен подходит к концу
        <FiveMinuteCountDownTimer />
      </div>
    </TimerProvider>
  );
});

FiveMinuteWarning.propTypes = {
  attempt: PropTypes.shape({
    exam_url_path: PropTypes.string.isRequired,
    exam_display_name: PropTypes.string.isRequired,
    time_remaining_seconds: PropTypes.number.isRequired,
    low_threshold_sec: PropTypes.number.isRequired,
    critically_low_threshold_sec: PropTypes.number.isRequired,
  }),
  stopExamAttempt: PropTypes.func.isRequired,
  expireExamAttempt: PropTypes.func.isRequired,
  submitExam: PropTypes.func.isRequired,
};

export default FiveMinuteWarning;
